import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/engine-displacement-calculator',
  component: () => import('../../routes/EngineDisplacementCalculator.svelte'),
  card: {
    id: 'engine-displacement-calculator',
    title: 'Engine Displacement',
    description:
      'Calculate engine displacement in cc, cubic inches (CID), and liters from bore, stroke, and cylinder count. Works for any engine (motorcycle, car, marine, small engines).',
    icon: 'settings',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/engine-displacement-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Engine Displacement Calculator – Bore × Stroke × Cylinders in cc, CID, L',
    description:
      'Free engine displacement calculator. Find total displacement in cubic centimeters (cc), cubic inches (CID), and liters from bore, stroke, and number of cylinders. Supports inches, mm, and cm for bore and stroke.',
  },
};

export default meta;
